<template>
    <div
        v-in-viewport="{ callback: () => loaded = true }"
        :class="{'isDisabled': disabled, 'isSmall': small}"
        class="item w-full h-full relative"
    >
        <div class="imageHolder w-full flex justify-center items-center">
            <img
                v-if="item.type === 'image' && loaded"
                :src="item.extension === 'svg' ? item.source : item.sizes.small.url"
                class="image ab100 objectFitCover"
            >
            <svg v-if="item.type !== 'image'" svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M13 2v7h7"/></svg>
            <MediaItemBar
                :show-settings="false"
                :show-picker="showPicker"
                :show-download="item.type !== 'image'"
                :file-url="item.source"
                @pickItem="$emit('pickItem')"
                @updateItem="$emit('updateItem')"
                @removeItem="$emit('removeItem')"
            />
            <p
                v-if="item.type !== 'image'"
                class="fileName"
            >
                {{ item.title }}.{{ item.extension }}
            </p>
        </div>
    </div>
</template>

<script>
import MediaItemBar from './MediaItemBar.vue';

export default {
    components: {
        MediaItemBar,
    },
    props: {
        showPicker: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        loaded: false,
    }),
};
</script>

<style lang="postcss" scoped>
.item.isDisabled {
    pointer-events: none;
    opacity: 0.25;
}
.imageHolder {
    background-color: var(--grey100);
    border-radius: var(--borderRadius);
    padding: 46% 0;
    overflow: hidden;
    position: relative;
}
.icon {
    width: 40px;
    height: 40px;
    color: var(--grey500);
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -20px;
    margin-top: -20px;
    @media (--laptop) {
        width: 30px;
        height: 30px;
        margin-left: -15px;
        margin-top: -15px;
    }
}
.fileName {
    position: absolute;
    left: 0;
    bottom: 15px;
    width: 100%;
    text-align: center;
    font-size: 13px;
    padding: 0 10px;
    color: var(--grey600);
    @media (--laptop) {
        font-size: 12px;
    }
}
.item:hover .mediaItemBar {
    opacity: 1;
    z-index: 1;
}
.isSmall .icon {
    display: none;
}
.isSmall .imageHolder {
    padding: 15px;
    min-height: 90px;
}
.isSmall .fileName {
    position: relative;
    bottom: auto;
    left: auto;
}
</style>
